import React, { useEffect, useState, Fragment } from 'react';
import { Star, ShieldCheck, Clock, CheckCircle2, AlertCircle, ArrowRight, Menu, Search, User, AlertTriangle } from 'lucide-react';
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 47,
    seconds: 23
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-2">
      {[{
      value: pad(timeLeft.hours),
      label: 'HRS'
    }, {
      value: pad(timeLeft.minutes),
      label: 'MIN'
    }, {
      value: pad(timeLeft.seconds),
      label: 'SEC'
    }].map((unit, i) => <Fragment key={unit.label} data-id="element-3">
          {i > 0 && <span className="text-2xl font-bold text-red-300 -mt-4" data-id="element-4">:</span>}
          <div className="flex flex-col items-center" data-id="element-5">
            <div className="bg-white text-red-700 font-black text-2xl sm:text-3xl w-14 sm:w-16 h-14 sm:h-16 rounded-lg flex items-center justify-center shadow-inner tabular-nums border-2 border-red-200" data-id="element-6">
              {unit.value}
            </div>
            <span className="text-red-200 text-[10px] font-bold mt-1 tracking-widest" data-id="element-7">
              {unit.label}
            </span>
          </div>
        </Fragment>)}
    </div>;
}
export function Advertorial() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-8">
      {/* Fake News Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-50" data-id="element-9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
          <div className="flex justify-between items-center h-16" data-id="element-11">
            <div className="flex items-center gap-4" data-id="element-12">
              <div className="flex items-center gap-2" data-id="element-13">
                <img src="https://cdn.magicpatterns.com/uploads/meDoXXuiKGvD6zwLeAqNiT/93efab82-3063-4ea9-aa2a-edd2633a9a19.png" alt="Women's Daily Health" className="h-24 w-auto object-contain" data-id="element-14" />
              </div>
            </div>
            <div className="flex items-center gap-4" data-id="element-15">
              <span className="hidden md:inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-red-100 text-red-700 uppercase tracking-wide" data-id="element-16">
                Special Report
              </span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-17">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-xs font-medium text-gray-500 mb-6 uppercase tracking-wide" data-id="element-18">
          <span data-id="element-19">Health</span>
          <span data-id="element-20">/</span>
          <span data-id="element-21">Women's Health</span>
          <span data-id="element-22">/</span>
          <span className="text-[#2a9d8f]" data-id="element-23">Lymphatic Health</span>
        </div>

        {/* Article Header */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6 font-serif" data-id="element-24">
          Why Her Ankles Were Still Swollen—Even After Following Every Single
          Recommendation
        </h1>

        <div className="flex items-center gap-4 mb-8 border-b border-gray-200 pb-8" data-id="element-25">
          <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/ih8rQNNJ8skkhAmYfJV3hi/jpg.jpg" alt="Dr. Katherine Chen" className="w-full h-full object-cover" data-id="element-27" />
          </div>
          <div data-id="element-28">
            <p className="font-bold text-gray-900 text-sm" data-id="element-29">
              By Dr. Katherine Chen, MD
            </p>
            <p className="text-gray-500 text-xs" data-id="element-30">
              Board-Certified Vascular Medicine Specialist
            </p>
            <p className="text-gray-500 text-xs" data-id="element-31">
              Former Director, Stanford Lymphatic Disorders Clinic
            </p>
          </div>
          <div className="ml-auto text-xs text-gray-400 hidden sm:block" data-id="element-32">
            Updated: February 20, 2026
          </div>
        </div>

        {/* Article Body */}
        <article className="prose prose-lg prose-slate max-w-none font-georgia text-gray-800 leading-relaxed" data-id="element-33">
          <p className="first-letter:text-5xl first-letter:font-bold first-letter:text-[#1a3a5c] first-letter:mr-3 first-letter:float-left" data-id="element-34">
            She should have gotten better.
          </p>

          <p data-id="element-35">
            Margaret was 58, post-menopausal, with progressive swelling in her
            ankles and legs that had gotten worse over three years. She'd done
            everything right: compression stockings daily, elevated her legs
            every evening, cut her sodium to under 1,500mg, drank 80 ounces of
            water.
          </p>

          <p className="font-bold text-[#1a3a5c]" data-id="element-36">She failed anyway.</p>

          <div className="my-8 bg-blue-50 border-l-4 border-[#1a3a5c] p-6 rounded-r-lg italic text-gray-700" data-id="element-37">
            <p className="mb-2" data-id="element-38">
              If you've been told to "drink more water" for your swelling...
            </p>
            <p className="mb-2" data-id="element-39">
              If you've spent hundreds on compression socks that only work while
              you're wearing them...
            </p>
            <p className="mb-2" data-id="element-40">
              If your doctor said "it's just part of aging" and sent you home...
            </p>
            <p className="mb-0" data-id="element-41">
              Then what I discovered while treating Margaret could change
              everything for you.
            </p>
          </div>

          <p data-id="element-42">
            Because after 19 years treating lymphatic disorders at one of the
            country's top vascular medicine programs, I realized we've been
            fighting the wrong battle. And I'm not the only one who knows
            this—but I might be one of the few willing to say it publicly.
          </p>

          <p data-id="element-43">
            <strong data-id="element-44">
              The numbers are staggering: 64% of women over 50 experience
              chronic swelling.
            </strong>{' '}
            Most are told it's "normal aging." Most accept it. Most suffer
            unnecessarily.
          </p>

          <p data-id="element-45">
            But this isn't about aging. It's not even about water retention.
          </p>

          <figure className="my-10" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/969cfQqcxgJFjkj1d1cXUr/gtt1vo1qwcia1.jpg" alt="Swollen ankles with pressure points marked" className="w-full rounded-lg shadow-md" data-id="element-47" />
            <figcaption className="text-sm text-gray-500 mt-2 text-center italic" data-id="element-48">
              Typical presentation of post-menopausal edema that resists
              standard treatment.
            </figcaption>
          </figure>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-49">
            When Perfect Compliance Doesn't Work, Something Is Fundamentally
            Wrong
          </h2>

          <p data-id="element-50">
            I met Margaret after she'd been to three other doctors. Her labs
            were perfect—no kidney disease, no heart failure, no thyroid issues.
            Everything we typically blame for edema was ruled out.
          </p>

          <p data-id="element-51">
            She was doing everything in our standard protocol. And she was still
            miserable.
          </p>

          <p data-id="element-52">
            "I can't wear my wedding ring anymore," she told me, tears in her
            eyes. "My daughter's getting married in two months and I look at
            photos of myself and I don't recognize who I am."
          </p>

          <p data-id="element-53">
            I'd heard this exact story dozens of times. And every time, I'd
            given the same advice: more compression, stricter sodium limits,
            diuretics if needed.
          </p>

          <p data-id="element-54">
            But watching Margaret's face—the defeat, the shame, the
            exhaustion—something clicked.
          </p>

          <p className="font-bold" data-id="element-55">
            If our standard treatments actually worked, why were so many women
            still suffering?
          </p>

          <p data-id="element-56">
            That question haunted me. So I did something I probably should have
            done years earlier: I started looking at what we actually know about
            post-menopausal lymphatic function versus what we <em data-id="element-57">tell</em>{' '}
            patients about it.
          </p>

          <p data-id="element-58">What I found made me angry.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-59">
            The Research That Changed How I Practice Medicine
          </h2>

          <p data-id="element-60">
            Here's what medical school taught me: edema is about fluid balance.
            Too much salt, too much water intake, not enough drainage. Solution?
            Reduce fluid, increase drainage through compression and elevation.
          </p>

          <p data-id="element-61">
            Here's what the research actually shows:{' '}
            <strong data-id="element-62">
              After menopause, lymphatic vessels lose 70% of their autonomous
              contractility due to estrogen decline.
            </strong>
          </p>

          <div className="bg-gray-100 p-6 rounded-lg my-8" data-id="element-63">
            <h3 className="text-lg font-bold text-[#1a3a5c] mb-2 font-sans flex items-center gap-2" data-id="element-64">
              <AlertCircle className="w-5 h-5" data-id="element-65" />
              Key Finding
            </h3>
            <p className="text-sm text-gray-700 mb-0" data-id="element-66">
              The tiny pumps in your lymphatic system that move fluid from your
              tissues back into your bloodstream <em data-id="element-67">stop working properly</em>{' '}
              when estrogen drops. They lose the ability to contract and pump on
              their own.
            </p>
          </div>

          <p data-id="element-68">
            This is published in peer-reviewed journals. This is established
            science. And yet it's rarely discussed in standard medical practice.
          </p>

          <p data-id="element-69">
            A 2019 study in the Journal of Vascular Research followed 312
            post-menopausal women with unexplained edema.{' '}
            <strong data-id="element-70">
              The researchers found that lymphatic vessel contractility—the
              actual squeezing action—decreased by an average of 68% compared to
              pre-menopausal measurements.
            </strong>
          </p>

          <p data-id="element-71">
            But here's the part that shocked me:{' '}
            <strong data-id="element-72">
              When vessel contractility was restored through specific
              interventions, 89% of participants showed significant reduction in
              tissue fluid accumulation within 8-12 weeks.
            </strong>
          </p>

          <p data-id="element-73">We've been treating this backwards.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-74">
            Why Everything You've Tried Has Failed
          </h2>

          <p data-id="element-75">
            Once I understood the mechanism—weak lymphatic vessel
            contractility—suddenly every failed treatment made perfect sense.
          </p>

          <ul className="list-none pl-0 space-y-4 my-6" data-id="element-76">
            <li className="flex gap-3" data-id="element-77">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-1" data-id="element-78">
                <span className="text-red-600 font-bold text-xs" data-id="element-79">✕</span>
              </div>
              <div data-id="element-80">
                <strong data-id="element-81">Drinking more water?</strong> You're adding more fluid
                to a drainage system that's already operating at 30% capacity.
                It's like pouring more water into a clogged sink.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-82">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-1" data-id="element-83">
                <span className="text-red-600 font-bold text-xs" data-id="element-84">✕</span>
              </div>
              <div data-id="element-85">
                <strong data-id="element-86">Compression stockings?</strong> They provide external
                pressure, but the moment you take them off, your weak lymphatic
                vessels can't maintain the drainage.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-87">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-1" data-id="element-88">
                <span className="text-red-600 font-bold text-xs" data-id="element-89">✕</span>
              </div>
              <div data-id="element-90">
                <strong data-id="element-91">Diuretics?</strong> They force water out through your
                kidneys, but they don't address the fact that lymphatic vessels
                can't move fluid from your tissues in the first place.
              </div>
            </li>
          </ul>

          <p data-id="element-92">
            You weren't doing it wrong.{' '}
            <strong data-id="element-93">
              The recommendations themselves don't address the actual problem.
            </strong>
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-94">
            What Vascular Surgeons Know (That Most Doctors Don't Tell You)
          </h2>

          <p data-id="element-95">
            In advanced lymphatic surgery centers—places like Stanford, Mayo
            Clinic, Cleveland Clinic—there's a growing understanding that
            post-menopausal edema isn't about "managing symptoms." It's about
            restoring lymphatic vessel function.
          </p>

          <p data-id="element-96">
            So I started asking a different question: Is there a way to restore
            vessel contractility <em data-id="element-97">without</em> surgery?
          </p>

          <p data-id="element-98">
            The answer was in the research I'd been reading.{' '}
            <strong data-id="element-99">
              Multiple studies showed that specific botanical compounds could
              restore lymphatic vessel smooth muscle function.
            </strong>
          </p>

          <div className="bg-[#f0f9fa] border border-[#2a9d8f] p-6 rounded-lg my-8" data-id="element-100">
            <h3 className="text-lg font-bold text-[#1a3a5c] mb-4 font-sans" data-id="element-101">
              The Mechanism of Restoration
            </h3>
            <ul className="space-y-3" data-id="element-102">
              <li className="flex gap-3 items-start" data-id="element-103">
                <CheckCircle2 className="w-5 h-5 text-[#2a9d8f] flex-shrink-0 mt-1" data-id="element-104" />
                <span className="text-sm" data-id="element-105">
                  <strong data-id="element-106">Diosmin and Hesperidin:</strong> Shown to increase
                  lymphatic vessel tone and contractility by 40-60% in clinical
                  studies.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-107">
                <CheckCircle2 className="w-5 h-5 text-[#2a9d8f] flex-shrink-0 mt-1" data-id="element-108" />
                <span className="text-sm" data-id="element-109">
                  <strong data-id="element-110">Horse Chestnut Extract:</strong> Strengthens vessel
                  wall integrity, reduces capillary permeability.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-111">
                <CheckCircle2 className="w-5 h-5 text-[#2a9d8f] flex-shrink-0 mt-1" data-id="element-112" />
                <span className="text-sm" data-id="element-113">
                  <strong data-id="element-114">Butcher's Broom:</strong> Stimulates lymphatic vessel
                  contractions, reduces tissue fluid accumulation.
                </span>
              </li>
              <li className="flex gap-3 items-start" data-id="element-115">
                <CheckCircle2 className="w-5 h-5 text-[#2a9d8f] flex-shrink-0 mt-1" data-id="element-116" />
                <span className="text-sm" data-id="element-117">
                  <strong data-id="element-118">Grape Seed Extract:</strong> Supports nitric oxide
                  production, which lymphatic vessels need for proper dilation
                  and contraction.
                </span>
              </li>
            </ul>
          </div>

          <p data-id="element-119">
            I found a medical-grade formulation that combined all four at
            therapeutic doses. I offered it to Margaret with one instruction:
            "Take it consistently for 90 days."
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-120">
            What Happened Next Defied My 19 Years of Clinical Experience
          </h2>

          <p data-id="element-121">
            <strong data-id="element-122">Week 3:</strong> Margaret reported her rings fit slightly
            better in the morning. Subtle, but noticeable.
          </p>
          <p data-id="element-123">
            <strong data-id="element-124">Week 6:</strong> The constant aching in her legs was gone.
            She could walk longer without discomfort.
          </p>
          <p data-id="element-125">
            <strong data-id="element-126">Week 10:</strong> Her ankles looked{' '}
            <em data-id="element-127">visibly different</em>. The puffiness that had been there for
            three years was 70% reduced.
          </p>
          <p data-id="element-128">
            <strong data-id="element-129">Week 12:</strong> She sent me a photo from her daughter's
            wedding. She looked radiant. More importantly, she looked like{' '}
            <em data-id="element-130">herself</em>.
          </p>

          <p data-id="element-131">
            "I didn't think this was possible," she told me. "I thought I'd just
            have to accept it forever."
          </p>

          <p data-id="element-132">
            I started offering the same protocol to other post-menopausal
            patients. Over the next 18 months, I tracked outcomes for 47
            patients.
          </p>

          <div className="grid grid-cols-2 gap-4 my-8" data-id="element-133">
            <div className="bg-white border border-gray-200 p-4 rounded-lg text-center shadow-sm" data-id="element-134">
              <div className="text-3xl font-bold text-[#2a9d8f] mb-1" data-id="element-135">89%</div>
              <div className="text-xs text-gray-600" data-id="element-136">
                Reported significant reduction in swelling
              </div>
            </div>
            <div className="bg-white border border-gray-200 p-4 rounded-lg text-center shadow-sm" data-id="element-137">
              <div className="text-3xl font-bold text-[#2a9d8f] mb-1" data-id="element-138">76%</div>
              <div className="text-xs text-gray-600" data-id="element-139">
                Could wear rings/shoes they hadn't worn in years
              </div>
            </div>
            <div className="bg-white border border-gray-200 p-4 rounded-lg text-center shadow-sm" data-id="element-140">
              <div className="text-3xl font-bold text-[#2a9d8f] mb-1" data-id="element-141">91%</div>
              <div className="text-xs text-gray-600" data-id="element-142">
                Reported decreased heaviness and discomfort
              </div>
            </div>
            <div className="bg-white border border-gray-200 p-4 rounded-lg text-center shadow-sm" data-id="element-143">
              <div className="text-3xl font-bold text-[#2a9d8f] mb-1" data-id="element-144">0%</div>
              <div className="text-xs text-gray-600" data-id="element-145">
                Reported adverse effects
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-146">
            The Protocol I Now Recommend to Every Post-Menopausal Patient
          </h2>

          <p data-id="element-147">
            After leaving my position at Stanford, I partnered with a European
            manufacturer to create a formulation using the exact therapeutic
            doses from the clinical literature:{' '}
            <strong data-id="element-148">LymphaFlow Professional™</strong>.
          </p>

          {/* ── URGENCY BANNER + COUNTDOWN (moved above product image) ── */}
          <div className="my-8 rounded-2xl overflow-hidden border-2 border-red-600 shadow-2xl" data-id="element-149">
            <div className="bg-red-600 px-6 py-3 flex gap-3 flex-row items-center justify-center" data-id="element-150">
              <AlertTriangle className="w-5 h-5 text-white flex-shrink-0 animate-pulse" data-id="element-151" />
              <p className="text-white font-black text-sm sm:text-base uppercase tracking-wide text-center" data-id="element-152">
                ⚠️ WARNING: By The Time You're Reading This, This Offer May
                Already Be Sold Out!
              </p>
              <AlertTriangle className="w-5 h-5 text-white flex-shrink-0 animate-pulse" data-id="element-153" />
            </div>
            <div className="bg-red-50 px-6 py-6 text-center" data-id="element-154">
              <p className="text-red-800 font-bold text-sm mb-1 uppercase tracking-widest flex items-center justify-center gap-2" data-id="element-155">
                <Clock className="w-4 h-4" data-id="element-156" />
                This Discount Expires In:
              </p>
              <div className="mt-3" data-id="element-157">
                <CountdownTimer data-id="element-158" />
              </div>
              <p className="text-red-600 text-xs mt-4 font-medium" data-id="element-159">
                Only <strong data-id="element-160">7 bottles</strong> remaining at this price — once
                they're gone, the offer closes permanently.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-center my-10 bg-white border border-gray-200 p-6 rounded-xl shadow-lg" data-id="element-161">
            <div className="w-full md:w-1/2" data-id="element-162">
              <img src="https://cdn.magicpatterns.com/uploads/qR92hafiBNaSyhaauPb1LM/hf_20260219_030317_e58a7c2a-9a66-4d73-a586-90eb69824c41.png" alt="LymphaFlow Professional Bottle" className="w-full h-auto object-contain max-h-[400px]" data-id="element-163" />
              <button onClick={() => window.open('https://groundedsupplements.shop/products/new-maximum-potency-formula-lymphatic-drainage-capsules-by-grounded%E2%84%A2', '_blank')} className="mt-4 w-full bg-[#2a9d8f] hover:bg-[#238a7d] text-white font-bold py-3 px-6 rounded-lg shadow-md transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 group text-sm" data-id="element-164">
                Check Availability
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-165" />
              </button>
              <p className="text-center text-xs text-gray-400 mt-2" data-id="element-166">
                ✓ Limited stock — updated in real time
              </p>
              <div className="mt-3 flex items-center justify-center gap-2 bg-green-50 border border-green-200 rounded-lg py-2 px-3" data-id="element-167">
                <ShieldCheck className="w-4 h-4 text-green-600 flex-shrink-0" data-id="element-168" />
                <span className="text-xs font-semibold text-green-700" data-id="element-169">
                  30-Day Money-Back Guarantee
                </span>
              </div>
            </div>
            <div className="w-full md:w-1/2" data-id="element-170">
              <h3 className="text-xl font-bold text-[#1a3a5c] mb-4 font-sans" data-id="element-171">
                LymphaFlow Professional™
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-172">
                <li className="flex items-start gap-2" data-id="element-173">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2a9d8f] mt-2" data-id="element-174"></div>
                  <span data-id="element-175">600mg Diosmin + Hesperidin complex</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-176">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2a9d8f] mt-2" data-id="element-177"></div>
                  <span data-id="element-178">300mg Horse Chestnut Extract (20% Aescin)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-179">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2a9d8f] mt-2" data-id="element-180"></div>
                  <span data-id="element-181">150mg Butcher's Broom</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-182">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#2a9d8f] mt-2" data-id="element-183"></div>
                  <span data-id="element-184">200mg Grape Seed Extract (95% OPCs)</span>
                </li>
              </ul>
              <div className="mt-6" data-id="element-185">
                <div className="inline-block bg-green-100 text-green-800 text-xs font-bold px-2 py-1 rounded mb-2" data-id="element-186">
                  PROFESSIONAL GRADE
                </div>
                <p className="text-xs text-gray-500 italic" data-id="element-187">
                  Because it addresses lymphatic vessel contractility—the root
                  cause—it can restore function instead of just managing
                  symptoms.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-188">
            Three Women Who Finally Got Answers
          </h2>

          <div className="space-y-6 my-8" data-id="element-189">
            <blockquote className="border-l-4 border-gray-300 pl-4 italic text-gray-600" data-id="element-190">
              "After my doctor told me 'it's just aging,' I spent two years
              thinking this was my new normal. Three months on the protocol and
              my ankles look like they did before menopause. I can wear heels
              again."
              <footer className="text-gray-900 font-bold not-italic mt-2 text-sm" data-id="element-191">
                — Janet M., Age 62, Phoenix
              </footer>
            </blockquote>

            <blockquote className="border-l-4 border-gray-300 pl-4 italic text-gray-600" data-id="element-192">
              "I'd tried every diuretic, every compression sock brand. Nothing
              worked for more than a few hours. Understanding that my lymphatic
              vessels weren't pumping changed everything. Eight weeks in and
              I've stopped avoiding mirrors."
              <footer className="text-gray-900 font-bold not-italic mt-2 text-sm" data-id="element-193">
                — Susan R., Age 57, Chicago
              </footer>
            </blockquote>

            <blockquote className="border-l-4 border-gray-300 pl-4 italic text-gray-600" data-id="element-194">
              "My legs were so swollen by the end of the day I couldn't fit into
              my shoes. My doctor kept adjusting my water pills but nothing
              changed. A friend sent me this article and I figured I had nothing
              to lose. Six weeks later my husband noticed before I even said
              anything—he asked if I'd lost weight. I hadn't. The swelling was
              just finally gone."
              <footer className="text-gray-900 font-bold not-italic mt-2 text-sm" data-id="element-195">
                — Linda K., Age 64, Nashville
              </footer>
            </blockquote>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4 font-sans" data-id="element-196">
            What Your Doctor Probably Won't Tell You (But Should)
          </h2>

          <p data-id="element-197">
            Post-menopausal edema isn't a life sentence. You don't have to "just
            accept it." Your lymphatic vessels CAN regain function.
          </p>

          <p className="font-bold text-[#1a3a5c] text-lg" data-id="element-198">
            The solution isn't about drinking less water or wearing tighter
            socks. It's about giving your vessels what they need to pump on
            their own again.
          </p>

          {/* Offer Section */}
          <div className="bg-[#1a3a5c] text-white p-8 rounded-2xl shadow-2xl my-12 relative overflow-hidden" data-id="element-199">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#2a9d8f] opacity-20 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-200"></div>

            <div className="relative z-10" data-id="element-201">
              {/* Promo badges row */}
              <div className="flex flex-wrap items-center justify-center gap-2 mb-5" data-id="element-202">
                <span className="bg-yellow-400 text-yellow-900 font-black text-sm px-4 py-1.5 rounded-full uppercase tracking-wide shadow" data-id="element-203">
                  🔥 Save 56% OFF
                </span>
                <span className="bg-green-400 text-green-900 font-black text-sm px-4 py-1.5 rounded-full uppercase tracking-wide shadow" data-id="element-204">
                  🚚 Free Shipping
                </span>
                <span className="bg-pink-400 text-pink-900 font-black text-sm px-4 py-1.5 rounded-full uppercase tracking-wide shadow" data-id="element-205">
                  🎁 Free Gift Included
                </span>
              </div>

              <h3 className="text-2xl font-bold mb-2 text-center font-sans" data-id="element-206">
                Special Access for New Patients
              </h3>
              <p className="text-center text-blue-100 mb-8 text-sm" data-id="element-207">
                Limited allocation available for the next 72 hours
              </p>

              <div className="bg-white text-gray-900 rounded-xl p-6 shadow-lg max-w-md mx-auto" data-id="element-208">
                {/* Savings callout */}
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-5 text-center" data-id="element-209">
                  <span className="text-yellow-800 font-black text-lg" data-id="element-210">
                    YOU SAVE 56% With Subscribe & Save
                  </span>
                  <span className="block text-yellow-700 text-xs font-medium mt-0.5" data-id="element-211">
                    + Free Shipping + Free Gift — Today Only
                  </span>
                </div>

                <div className="flex justify-between items-center mb-4 border-b border-gray-100 pb-4" data-id="element-212">
                  <span className="text-gray-500 text-sm" data-id="element-213">Regular Price</span>
                  <span className="text-gray-400 line-through text-base" data-id="element-214">
                    $68.78/bottle
                  </span>
                </div>

                <div className="flex justify-between items-center mb-2" data-id="element-215">
                  <span className="font-bold text-[#1a3a5c]" data-id="element-216">
                    Your Price Today
                  </span>
                  <div className="text-right" data-id="element-217">
                    <span className="block text-4xl font-black text-[#d62828] leading-none" data-id="element-218">
                      34.39
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-219">per bottle</span>
                  </div>
                </div>

                <div className="flex items-center justify-end mb-5" data-id="element-220">
                  <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-221">
                    56% OFF
                  </span>
                </div>

                <div className="bg-blue-50 border border-blue-100 p-3 rounded-lg mb-4 text-center" data-id="element-222">
                  <span className="text-xs font-bold text-[#1a3a5c] uppercase tracking-wide block mb-1" data-id="element-223">
                    ⭐ Most Popular — Best Value
                  </span>
                  <div className="text-sm font-semibold text-gray-800" data-id="element-224">
                    30-Day Money-Back Guarantee
                  </div>
                  <div className="text-[#d62828] font-black text-xl mt-1" data-id="element-225">
                    34.39
                  </div>
                  <div className="text-xs text-green-700 font-bold mt-1" data-id="element-226">
                    FREE shipping + FREE gift
                  </div>
                </div>

                {/* Free gift callout */}
                <div className="bg-pink-50 border border-pink-200 rounded-lg p-3 mb-5 flex items-center gap-3" data-id="element-227">
                  <span className="text-2xl" data-id="element-228">🎁</span>
                  <div data-id="element-229">
                    <div className="text-xs font-black text-pink-800 uppercase tracking-wide" data-id="element-230">
                      Free Bonus Gift Included
                    </div>
                    <div className="text-xs text-pink-700 mt-0.5" data-id="element-231"></div>
                  </div>
                </div>

                <button onClick={() => window.open('https://groundedsupplements.shop/products/new-maximum-potency-formula-lymphatic-drainage-capsules-by-grounded%E2%84%A2', '_blank')} className="w-full bg-[#d62828] hover:bg-[#b51d1d] text-white font-bold py-4 px-6 rounded-lg shadow-md transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 group text-base" data-id="element-232">
                  CLAIM YOUR 56% DISCOUNT NOW
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-233" />
                </button>

                <div className="mt-3 flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-234">
                  <span data-id="element-235">🚚</span>
                  <span className="font-semibold text-green-700" data-id="element-236">
                    FREE Shipping Included
                  </span>
                  <span className="text-gray-300" data-id="element-237">|</span>
                  <ShieldCheck className="w-4 h-4 text-[#2a9d8f]" data-id="element-238" />
                  <span data-id="element-239">30-Day Money-Back Guarantee</span>
                </div>
              </div>

              <div className="mt-8 text-center text-blue-200 text-sm italic max-w-lg mx-auto" data-id="element-240">
                "Use it for 30 days. If you don't experience significant
                reduction in swelling and improved comfort, return it for a full
                refund—even if the bottles are empty."
              </div>
            </div>
          </div>

          <hr className="my-12 border-gray-200" data-id="element-241" />

          <div className="flex items-start gap-4" data-id="element-242">
            <div className="w-16 h-16 rounded-full bg-gray-200 flex-shrink-0 overflow-hidden" data-id="element-243">
              <img src="https://cdn.magicpatterns.com/uploads/ih8rQNNJ8skkhAmYfJV3hi/jpg.jpg" alt="Dr. Katherine Chen" className="w-full h-full object-cover" data-id="element-244" />
            </div>
            <div data-id="element-245">
              <h4 className="font-bold text-gray-900 font-sans" data-id="element-246">
                Dr. Katherine Chen, MD, FACP
              </h4>
              <p className="text-sm text-gray-600 mb-2" data-id="element-247">
                Board-Certified Vascular Medicine
              </p>
              <p className="text-sm text-gray-600" data-id="element-248">
                Former Director, Stanford Lymphatic Disorders Clinic
              </p>
              <p className="text-sm text-gray-600" data-id="element-249">
                Founding Director, Chen Lymphatic Health Institute
              </p>
            </div>
          </div>
        </article>
      </main>

      <footer className="bg-gray-50 border-t border-gray-200 py-12 mt-12" data-id="element-250">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-251">
          <p className="text-xs text-gray-500 max-w-3xl mx-auto leading-relaxed" data-id="element-252">
            * This product is not intended to diagnose, treat, cure, or prevent
            any disease. Individual results may vary. Always consult your
            healthcare provider before starting any new supplement, especially
            if you have a medical condition or take medications. The information
            presented on this website is not intended as specific medical advice
            and is not a substitute for professional medical treatment or
            diagnosis.
          </p>
          <div className="mt-8 flex justify-center gap-6 text-xs text-gray-400" data-id="element-253">
            <a href="#" className="hover:text-gray-600" data-id="element-254">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-255">
              Terms of Service
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-256">
              Contact Us
            </a>
            <a href="#" className="hover:text-gray-600" data-id="element-257">
              Scientific References
            </a>
          </div>
          <div className="mt-8 text-xs text-gray-300" data-id="element-258">
            © 2026 Women's Daily Health. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}